var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarBorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3314_2960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6523 9.04L14.8123 8.62L12.9223 4.17C12.5823 3.36 11.4223 3.36 11.0823 4.17L9.19227 8.63L4.36227 9.04C3.48227 9.11 3.12227 10.21 3.79227 10.79L7.46227 13.97L6.36227 18.69C6.16227 19.55 7.09227 20.23 7.85227 19.77L12.0023 17.27L16.1523 19.78C16.9123 20.24 17.8423 19.56 17.6423 18.7L16.5423 13.97L20.2123 10.79C20.8823 10.21 20.5323 9.11 19.6523 9.04ZM12.0023 15.4L8.24227 17.67L9.24227 13.39L5.92227 10.51L10.3023 10.13L12.0023 6.1L13.7123 10.14L18.0923 10.52L14.7723 13.4L15.7723 17.68L12.0023 15.4Z",
    fill: "#282860"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3314_2960"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarBorder);
export default __webpack_public_path__ + "static/media/star_border.99b1591dd631fe62de912463c43a9a02.svg";
export { ForwardRef as ReactComponent };